module.exports = __webpack_public_path__ + "img/portrait-101.c5e3af39.jpg";